import * as yup from "yup";

export const getCancelRequestValidationSchema = () => {
  return yup.object().shape({
    comment: yup.string().trim().required("Response required"),
    caseRetention: yup.string().oneOf(["true", "false"]).required("A selection is required"),
  });
};
